import React, { useEffect } from "react";
import { useLocation } from "wouter";

export const SlashPage = (): React.ReactElement => {
    const [, navigate] = useLocation();
    useEffect(() => {
        navigate("/client", { replace: true });
    }, [navigate]);

    return <div></div>;
};
